import { CollapsibleSectionContainer } from '@stern-ui/ui';

type PatientListFiltersFormSectionProps = {
	title: string;
	dataTestId: string;
	children: React.ReactElement;
	isFirstSection?: boolean;
};

export const PatientListFiltersFormSection = (props: PatientListFiltersFormSectionProps) => {
	const { title, dataTestId, children, isFirstSection = false } = props;
	return (
		<div className={`${isFirstSection ? '' : 'pt-5'}`}>
			<CollapsibleSectionContainer
				isEditable={false}
				title={title}
				isFullWidth={true}
				dataTestId={dataTestId}
			>
				{children}
			</CollapsibleSectionContainer>
			<div className='border-b border-secondaryBorder mx-3 mt-4'></div>
		</div>
	);
};
